import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import { render } from 'react-dom';
import React, { Component, createRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { CLS_PREFIX, Z_INDEX_TOASTER } from '../../constants';
import Toast from '../Toast';
import Layer from '../Layer';
import OnDarkContext from '../OnDarkContext';
var toastId = 0;

/**
 * `Toaster` is used for notifying about events happened in the system. For example, about results of performed operations.
 * @since 0.0.42
 */
var Toaster =
/*#__PURE__*/
function (_Component) {
  _inherits(Toaster, _Component);

  function Toaster() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Toaster);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Toaster)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      toasts: []
    });

    return _this;
  }

  _createClass(Toaster, [{
    key: "isControlled",
    value: function isControlled() {
      return Boolean(this.props.toasts);
    }
    /**
     * Add a new toast
     *
     * `intent` - Visual intent color to apply to component. (Type: `oneOf` 'info', 'success', 'warning', 'danger'. *Required*.)<br>
     * `message` - Message to display in the body of the toast. (Type: `any`. Default: `undefined`.)<br>
     * `onClose` - onClose handler. (Type: `func`. Default: `undefined`.)<br>
     * `closable` - Show close control (cross mark). (Type: `boolean`. Default: `true`.)<br>
     * `autoClosable` - Whether call `onClose` after 6 seconds or not.
     * Enabled by default when the position is "top-end" and a toast has "success" intent. (Type: `boolean`. Default: 'undefined'.)<br>
     * ---
     * @param {Object} props **Toast props**:
     * @returns {string} New toast key
     * @public
     */

  }, {
    key: "add",
    value: function add(props) {
      var _this2 = this;

      var key = "toast-".concat(toastId++);
      this.setState(function (_ref) {
        var toasts = _ref.toasts;
        return {
          toasts: [_objectSpread({
            key: key
          }, props)].concat(_toConsumableArray(toasts)).slice(0, _this2.props.maxToastsNumber)
        };
      });
      return key;
    }
    /**
     * Update toast by key
     *
     * @param {string} key
     * @param {Object} props New props
     * @returns {string} Updated toast key
     * @public
     */

  }, {
    key: "update",
    value: function update(key, props) {
      this.setState(function (_ref2) {
        var toasts = _ref2.toasts;
        return {
          toasts: toasts.map(function (toast) {
            return toast.key === key ? _objectSpread({}, props, {
              key: key
            }) : toast;
          })
        };
      });
      return key;
    }
    /**
     * Remove toast by key
     *
     * @param {string} key
     * @public
     */

  }, {
    key: "remove",
    value: function remove(key) {
      this.setState(function (_ref3) {
        var toasts = _ref3.toasts;
        return {
          toasts: toasts.filter(function (toast) {
            return toast.key !== key;
          })
        };
      });
    }
    /**
     * Clear all toasts
     *
     * @public
     */

  }, {
    key: "clear",
    value: function clear() {
      this.setState({
        toasts: []
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          toasts = _this$props.toasts,
          maxToastsNumber = _this$props.maxToastsNumber,
          position = _this$props.position,
          onToastClose = _this$props.onToastClose,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "toasts", "maxToastsNumber", "position", "onToastClose"]);

      var stack = this.state.toasts;

      if (position === 'bottom-end') {
        stack = _toConsumableArray(stack);
        stack.reverse();
      }

      return React.createElement(OnDarkContext.Provider, {
        value: true
      }, React.createElement(Layer, {
        level: Z_INDEX_TOASTER
      }, React.createElement("div", _extends({
        className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "--").concat(position), position), className)
      }, props), React.createElement(TransitionGroup, {
        component: "span"
      }, stack.map(function (toastProps) {
        var intent = toastProps.intent;
        var autoClosable = toastProps.autoClosable;

        if (autoClosable === undefined && intent === 'success' && position === 'top-end') {
          autoClosable = true;
        }

        var toastRef = createRef();
        return React.createElement(CSSTransition, {
          key: toastProps.key,
          classNames: "".concat(Toast.defaultProps.baseClassName, "-"),
          timeout: {
            enter: 300,
            exit: 300
          },
          nodeRef: toastRef
        }, React.createElement(Toast, _extends({}, toastProps, {
          autoClosable: autoClosable,
          onClose: function onClose() {
            if (!_this3.isControlled()) {
              _this3.remove(toastProps.key);
            }

            if (toastProps.onClose) {
              toastProps.onClose();
            }

            if (onToastClose) {
              onToastClose(toastProps.key);
            }
          },
          innerRef: toastRef
        })));
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref4) {
      var toasts = _ref4.toasts,
          maxToastsNumber = _ref4.maxToastsNumber;

      if (toasts) {
        return {
          toasts: toasts.slice(0, maxToastsNumber)
        };
      }

      return null;
    }
  }]);

  return Toaster;
}(Component);

_defineProperty(Toaster, "defaultProps", {
  position: 'top-end',
  baseClassName: "".concat(CLS_PREFIX, "toaster")
});

_defineProperty(Toaster, "create", function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  var containerElement = document.createElement('div');
  container.appendChild(containerElement);
  return render(React.createElement(Toaster, props), containerElement);
});

export { Toaster as default };